import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'add_card_file';

export const useAddCardFileTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить файл',
    name: 'Название',
    submit: 'Сохранить',
    cancel: 'Отмена',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add file',
    name: 'Name',
    submit: 'Save',
    cancel: 'Cancel',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Añadir archivo',
    name: 'Nombre',
    submit: 'Guardar',
    cancel: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar arquivo',
    name: 'Nome',
    submit: 'Salvar',
    cancel: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;
